// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mkb-mobile-menu{margin-left:-15px;margin-right:-15px;margin-bottom:30px!important}.mkb-mobile-footer-logo{margin-top:4rem}.mkb-footer-logo{width:60%;height:auto}.mkb-footer-logo path{fill:#9eaab3!important}", ""]);
// Exports
module.exports = exports;
